import React from 'react';
import type { CSSProperties } from 'react';

import styles from './AiAgentAvatar.module.css';

type AiAgentAvatarProps = {
  /** Accessible label, usually the localized "AI Agent" name. */
  name?: string;
  size?: number;
  className?: string;
  /** Soft pulse used while the agent is working on a reply. */
  pulse?: boolean;
};

/**
 * Avatar for the workspace AI agent. Deliberately distinct from employee avatars
 * (gradient + sparkle instead of initials) so AI authors and AI mentions read at a glance.
 */
export const AiAgentAvatar: React.FC<AiAgentAvatarProps> = ({ name, size = 30, className, pulse = false }) => {
  const style = {
    width: size,
    height: size,
    ['--ai-avatar-size' as string]: `${size}px`,
  } as CSSProperties;

  return (
    <span
      className={[styles.avatar, pulse ? styles.pulse : '', className].filter(Boolean).join(' ')}
      style={style}
      role="img"
      aria-label={name || 'AI agent'}
      title={name}
    >
      <svg className={styles.icon} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          fill="currentColor"
          d="M12 2.5l1.9 5.1 5.1 1.9-5.1 1.9L12 16.5l-1.9-5.1L5 9.5l5.1-1.9L12 2.5zM5 15l.95 2.55L8.5 18.5l-2.55.95L5 22l-.95-2.55L1.5 18.5l2.55-.95L5 15zm14 .5l.75 2 2 .75-2 .75L19 21l-.75-2-2-.75 2-.75.75-2z"
        />
      </svg>
    </span>
  );
};

export default AiAgentAvatar;
